<!--
 * @Author: zsh
 * @Date: 2020-06-23 10:06:43
 * @LastEditors: zsh
 * @LastEditTime: 2020-07-03 11:33:33
 * @FilePath: /official-website/src/App.vue
 -->
<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  beforeCreate() {
    this.$nextTick(function () {
      this.handleIsPc()
    })
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    handleIsPc () {
      let mobileAgent = new Array("iphone", "ipod", "ipad", "android", "mobile", "blackberry", "webos", "incognito", "webmate", "bada", "nokia", "lg", "ucweb", "skyfire");
      let browser = navigator.userAgent.toLowerCase();
      let isMobile = false;
      for (let i=0; i<mobileAgent.length; i++){
        if (browser.indexOf(mobileAgent[i])!=-1){
          isMobile = true;
          // this.$http.post(this.API.about.tools_http_host).then(res => {
          //   if(res.status == 0){
              // let href = 'http://' + res.data.http_host + '/H5/dist/#/home'
              location.href = this.$api.httphost
          //   }
          // })
          break;
        }
      }
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue